import React from "react";
import { Card, Space, Typography } from "antd";
const { Title } = Typography;

interface CardData {
    title: string;
    content: React.ReactNode;
    link?: string;
}

interface DashboardProps {
    card: CardData;
}

const DashboardCard: React.FC<DashboardProps> = ({ card }) => {
    return (
        <Card bordered={false}>
            <Space direction="vertical" style={{ width: '100%' }}>
                <Title level={5}>{card.title}</Title>
                {card.content}
                <div style={{ textAlign: "right", marginTop: "10px" }}>
                    <a href="/view-all">View all</a>
                </div>
            </Space>
        </Card>
    );
};

export default DashboardCard;
